import clsx from 'clsx'
import React, { forwardRef, useId } from 'react'

type Gap = 2 | 3 | 6

export interface CheckboxGroupProps {
  children: React.ReactNode;
  description?: React.ReactNode;
  disabled?: boolean;
  gap?: Gap;
  label?: React.ReactNode;
  layout?: 'horizontal' | 'vertical';
}

const GAP_CLASS_MAPPING: Record<Gap, string> = {
  2: 'gap-2',
  3: 'gap-3',
  6: 'gap-6',
}

function gapClass (gap: Gap) {
  return GAP_CLASS_MAPPING[gap] || 'gap-2'
}

export const CheckboxGroup = forwardRef<
  HTMLFieldSetElement,
  CheckboxGroupProps
>(
  (
    { children, description, disabled, gap = 2, label, layout = 'vertical' },
    forwardedRef
  ) => {
    const descriptionId = useId()

    return (
      <fieldset
        aria-describedby={description ? descriptionId : undefined}
        disabled={disabled}
        ref={forwardedRef}
      >
        {!!label && (
          <legend className='body-sm-bold text-gray-800 mb-2'>{label}</legend>
        )}
        <div
          className={clsx('flex', gapClass(gap), {
            'flex-col': layout === 'vertical',
            'flex-row flex-wrap': layout === 'horizontal',
          })}
        >
          {children}
        </div>
        {!!description && (
          <div id={descriptionId} className='body-sm text-gray-500 mt-2'>
            {description}
          </div>
        )}
      </fieldset>
    )
  }
)
